import { DataVersion, IncidentProduct } from '@hakimo-ui/hakimo/types';
import { withDataVersion } from '@hakimo-ui/hakimo/util';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useUploadIncidentReportLogo(
  product: IncidentProduct,
  alarmId: number | string,
  onSuccess?: () => void,
  onError?: (err: Error) => void,
  dataVersion?: DataVersion
) {
  const searchParams = new URLSearchParams({ product });
  const request = new Request(
    `/v2/orm/location_incidents/report-logo?${searchParams.toString()}`,
    { method: 'PUT' }
  );
  withDataVersion(request, dataVersion);

  return useAuthenticatedMutation<null, File>(request, {
    onSuccessInvalidationKeys: [['incidentDetail']],
    onSuccess,
    onError,
    getBody: (file) => {
      const formData = new FormData();
      formData.append('alarm_id', String(alarmId));
      formData.append('logo', file);
      return formData;
    },
    responseModifier: async () => null,
  });
}

export default useUploadIncidentReportLogo;
